import React, { useEffect, useState } from 'react'
import './style.scss'
import '../search-customer/search-customer.scss'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { customerAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import NormalInput from '../../components/common/inputs/NormalInput'
import SelectInput from '../../components/common/inputs/SelectInput'
import { BiLoaderAlt } from 'react-icons/bi'
import { FcDeleteDatabase, FcSearch } from 'react-icons/fc'
import { FaWhatsapp } from 'react-icons/fa6'
import { IoCheckmarkDoneCircleOutline, IoCheckmarkCircleOutline, IoCloseCircleOutline, IoTimeOutline } from 'react-icons/io5'
import { convertIsoToAmPm, formateDateToDayText } from '../../assets/javascript/formate-functions'
import WaSendReport from '../../components/user/wa-send-report/WaSendReport'

const WaSendStatusList = () => {
    const [modal, setModal] = useState({ status: false })
    const [loading, setLoading] = useState('fetch')
    const [data, setData] = useState([])
    const [form, setForm] = useState({ asot_types: [], key: '' })
    const [ifSearch, setIfSearch] = useState(false)
    const [templateNames, setTemplateNames] = useState([])
    const [contentLimit, setContentLimit] = useState({ page: 1, limit: 50 })
    const [seeMore, setSeeMore] = useState(true)

    const openModal = (item) => {
        setModal({
            status: true, title: 'Message Details', content: <WaSendReport data={item} />
        })
    }

    const messageTypes = [
        { option: 'Template', value: 'template' },
        { option: 'Individual', value: 'individual' },
    ]

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const fetchData = (page, limit, newFetch) => {
        setLoading('fetch')
        customerAxios.get(
            `/p/v2/wa/report/send-list?page=${page}&limit=${limit}${form.start_date ? `&start_date=${form.start_date}` : ''}${form.end_date ? `&end_date=${form.end_date}` : ''}${form.message_type ? `&message_type=${form.message_type}` : ''}${form.template_name ? `&template_name=${form.template_name}` : ''}${form.wa_number ? `&wa_number=${form.wa_number}` : ''}`)
            .then((response) => {
                setIfSearch(true)
                if (newFetch) {
                    setData(response.data)
                } else {
                    setData([...data, ...response.data])
                }

                if (response.data.length < limit) {
                    setSeeMore(false)
                } else {
                    setSeeMore(true)
                }
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
    }

    const handleApply = (e) => {
        e.preventDefault();
        setContentLimit({ ...contentLimit, page: 1 })
        fetchData(1, contentLimit.limit, 'newFetch')
    }

    useEffect(() => {
        // fetch template name list
        customerAxios.get('/p/v2/wa/template/list').then((response) => {
            setTemplateNames(response.data)
        })
    }, [])

    return (
        <div className="wa-send-report-page-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['WhatsApp Message Send Status']}>
                <div className="search-border-div">
                    <div className="filter-border-div">
                        <form action="" onSubmit={handleApply} >
                            <div className="search-section">
                                <h5>Date range</h5>
                                <NormalInput label='From Date *' type={'date'} name='start_date' value={form.start_date} onChangeFun={handleChange} max={form?.end_date} />
                                <NormalInput label='End Date *' type={'date'} name='end_date' value={form.end_date} onChangeFun={handleChange} min={form?.start_date} />
                            </div>
                            <div className="search-section">
                                <h5>Message type</h5>
                                <SelectInput label='Message type' name='message_type' values={messageTypes} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />

                                {form?.message_type !== 'individual' && <SelectInput label='Template name' name='template_name' values={templateNames?.map((a) => ({ option: a, value: a, selected: a === form.template_name }))} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />}
                            </div>

                            <div className="search-section">
                                <h5>Whatsapp number (Send to)</h5>
                                <NormalInput type={'number'} label='Enter with country code' name='wa_number' value={form.wa_number} onChangeFun={handleChange} isRequired={false}
                                    placeholder={'Ex : 919876543210'} />
                            </div>

                            <div className="button-div">
                                <button type='submit'>{loading === 'filter' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Filter"}</button>
                            </div>
                        </form>
                    </div>
                    <div className="result-div">
                        {data?.[0] ?
                            <div className='result-list'>
                                {data?.map((item) => {
                                    const lastStatus = item?.status_flow?.[item?.status_flow?.length - 1] || null;
                                    return <div key={item?._id} className="item" onClick={() => openModal(item)}>
                                        <div className="s-one">
                                            <h4>{item?.message_type === 'template' ? item?.template : 'Individual'}</h4>
                                            <p>{item?.wa_sender_id}</p>
                                        </div>
                                        <div className="s-two">
                                            <p>Send to</p>
                                            <div className="number">
                                                <p>{item?.send_to}</p>
                                                {(lastStatus && lastStatus?.status !== 'failed') && <FaWhatsapp />}
                                            </div>
                                        </div>
                                        <div className="s-three ">
                                            {item?.message_status !== 'success' && <>
                                                <span className='failed'>
                                                    <IoCloseCircleOutline />
                                                    <h4>Error</h4>
                                                </span>
                                                <p>{convertIsoToAmPm(item?.time)}, {formateDateToDayText(item?.time)}</p>
                                            </>}
                                            {(item?.message_status === 'success' && !lastStatus) && <>
                                                <span className='pending'>
                                                    <IoTimeOutline />
                                                    <h4>Pending</h4>
                                                </span>
                                                <p>{convertIsoToAmPm(item?.time)}, {formateDateToDayText(item?.time)}</p>
                                            </>}
                                            {(item?.message_status === 'success' && lastStatus) && <>
                                                <span className={lastStatus?.status}>
                                                    {lastStatus?.status === 'read' ? < IoCheckmarkDoneCircleOutline />
                                                        : lastStatus?.status === 'delivered' ? <IoCheckmarkDoneCircleOutline />
                                                            : lastStatus?.status === 'sent' ? <IoCheckmarkCircleOutline />
                                                                : lastStatus?.status === 'failed' ? <IoCloseCircleOutline /> : ''}
                                                    <h4>{lastStatus?.status}</h4>
                                                </span>
                                                <p>{convertIsoToAmPm(item?.time)}, {formateDateToDayText(item?.time)}</p>
                                            </>}
                                        </div>
                                    </div>
                                })}

                                {seeMore && <div className="button-div" style={{ justifyContent: 'center', marginTop: '10px' }}>
                                    <button onClick={() => {
                                        const newPage = contentLimit.page + 1
                                        setContentLimit({ ...contentLimit, page: newPage })
                                        fetchData(newPage, contentLimit.limit)
                                    }} >{loading === 'fetch' ? <span className='loading-icon'><BiLoaderAlt /></span> : "See More"}</button>
                                </div>}
                            </div>
                            : <>
                                <SpinWithMessage height={'300px'} spin={false} message={ifSearch ? 'No matched data' : 'Search to see result'} icon={ifSearch ? <FcDeleteDatabase /> : <FcSearch />} />
                            </>}
                    </div>
                </div>
            </SinglePage>
        </div>
    )
}

export default WaSendStatusList